import {
	INVESTOR_TEST_ELEMENT_ID,
	UIElementIdentifier,
} from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';
import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Flex, Title } from '@mantine/core';
import { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { TextInput } from 'react-hook-form-mantine';

interface Props {
	disabled?: boolean;
	pivNameFieldName: string;
	pivRegNumberFieldName: string;
}

const PivBasicInformationInput = ({ pivNameFieldName, pivRegNumberFieldName, disabled }: Props) => {
	const tInvestor = useTranslationInvestor();
	const formContext = useFormContext();

	return (
		<Flex direction="column" gap="1rem" w="100%">
			<Title order={6}>{tInvestor('investment.piv.basic_information')}</Title>

			<UIElementIdentifier
				identifier={INVESTOR_TEST_ELEMENT_ID.INVESTOR_PERSONAL_INFORMATION_PIV_NAME}
			>
				<TextInput
					label={tInvestor('investment.piv.piv_info_form.name')}
					placeholder={tInvestor('investment.piv.piv_info_form.name')}
					control={formContext.control}
					name={pivNameFieldName}
					size="md"
					disabled={disabled}
				/>
			</UIElementIdentifier>

			<UIElementIdentifier
				identifier={INVESTOR_TEST_ELEMENT_ID.INVESTOR_PERSONAL_INFORMATION_PIV_REG_NUMBER}
			>
				<TextInput
					label={tInvestor('investment.piv.piv_info_form.corp_number')}
					placeholder={tInvestor('investment.piv.piv_info_form.corp_number')}
					control={formContext.control}
					name={pivRegNumberFieldName}
					size="md"
					disabled={disabled}
				/>
			</UIElementIdentifier>
		</Flex>
	);
};
const _PivBasicInformationInputExport = memo(PivBasicInformationInput);

export { _PivBasicInformationInputExport as PivBasicInformationInput };
